export class SellpiaInfo {
    constructor(id, product_uid) {
       this.id = id;
       this.product_uid = product_uid;
    }

    loader() {
       let self = this;
       return Promise.all([
           SellpiaInfo.loadSellpiaProduct(this.id, this.product_uid)
               .then((option_data) => {
                   self.option_data = option_data;
               }).catch(e=>{
                   self.option_data = {};
                   throw e;
               }),
           SellpiaInfo.loadSellpiaInfo(this.id)
               .then((info)=>{
                   self.info = info?.env || {};
               }).catch(e=>{
                   self.info = {};
                   throw e;
               })
           ])
    }

    getOptionInfo() {
        return this.option_data;
    }

    getLastUpdate() {
        return this.option_data?.[Object.keys(this.option_data)?.[0]]?.last_datetime || false
    }

    static sellpia_product_url = "https://sellpia-product.makeshop.co.kr/makeshop"
    static loadSellpiaInfo(id) {
        if (!id) {
            throw new Error("상점 정보가 누락되었거나. 가상테그가 잘 못 적용 되었습니다. ( <!--/json/shop_info/--> )");
        }

        let $T = window.$ || window.jQuery; // ie 11 용

        if (typeof(fetch) == "function") {
            return fetch(this.sellpia_product_url + "/" + id + "/env.json")
                .then(function (response) {
                    return response.json();
                });
        } else if ($T && typeof($T.get) == "function") {
            return new Promise((resolve, reject)=>{
                $T.get(this.sellpia_product_url + "/" + id + "/env.json", function (data) {
                    resolve(JSON.parse(data));
                },"text").fail(function () {
                    reject(new Error("셀피아 환경 파일을 읽어 올 수 없습니다."));
                });
            })
        } else {
            return Promise.reject("err");
        }
    }

    static loadSellpiaProduct(id, uid) {
        if (!uid || !id) {
            throw new Error("상품정보가 누락되었거나. 가상테그가 잘 못 적용 되었습니다. ( <!--/json/brand_info/-->, <!--/json/shop_info/--> )");
        }

        let $T = window.$ || window.jQuery; // ie 11 용

        if (typeof(fetch) == "function") {
            return fetch("https://sellpia-product.makeshop.co.kr/makeshop/" + id + "/" + uid + ".json")
                .then(function (response) {
                    return response.json();
                })
                .then(function (myJson) {
                    return SellpiaInfo.SellpiaInfoToOptions(myJson);
                });
        } else if ($T && typeof($T.get) == "function") {
            return new Promise((resolve, reject)=>{
                $T.get("https://sellpia-product.makeshop.co.kr/makeshop/" + id + "/" + uid + ".json", function (data) {
                    resolve(SellpiaInfo.SellpiaInfoToOptions(JSON.parse(data)));
                },"text").fail(function () {
                    reject(new Error("errr"));
                });
            })
        } else {
            return Promise.reject("err");
        }
    }

    static SellpiaInfoToOptions(sellpia_info) {
        let keys = Object.keys(sellpia_info);
        keys.map(key => {
            if (sellpia_info[key].option_title == "") {
                sellpia_info[key].option_title = "단일 옵션 상품";
            }
            if (!sellpia_info[key].option_title_extra) {
                sellpia_info[key].option_title_extra = "옵션";
            }
        })
        return sellpia_info;
    }
}